
import { computed, defineComponent, ref, onMounted } from 'vue'
import useRouter from '../../../../../hooks/useRouter'
import { useProject } from '../../../../../hooks/useProject'
import { CONNECTOR_TYPES } from '../../../../../vars/general'
import api from '../../../../../api/api'
import CustomActivatorSelect from '../../../../inputs/CustomActivatorSelect.vue'
import BaseInputOutlined from '../../../../inputs/BaseInputOutlined.vue'
import phoneValidator, { isValidPhone } from '../../../../../helpers/validators/phoneValidator'
import PhoneInputGroup from '@root/src/components/ui/PhoneInputGroup.vue'
export default defineComponent({
    props: {
        value: {
            type: Object,
            required: true,
        },
        app: {
            type: Object,
            required: true,
        },
    },
    components: { CustomActivatorSelect, BaseInputOutlined, PhoneInputGroup },
    setup(props, { emit }) {
        const { route } = useRouter()
        const trigger = computed(() => route.value.query.id)
        const { project } = useProject()
        const activeTab = ref(0)
        const staff = ref([])

        const hasYcConnector = computed(() => {
            return project.value.connectors.some(
                connector => connector.connectorType === CONNECTOR_TYPES.yClients
            )
        })
        const tabs = computed(() => {
            return [
            {
                tabName: 'Только для этого тригерра',
                key: 'trigger',
                isColored: props.value?.banOnClient && props.value.banOnClient.some((el: string) => !isValidPhone(el)),
                ref: 0,
                isActive: activeTab.value === 0
            },
            {
                tabName: 'Для всех тригерров',
                key: 'app',
                isColored: props.app.banOnClient && props.app.banOnClient.some((el: string) => !isValidPhone(el)),
                ref: 1,
                isActive: activeTab.value === 1
            },
        ]
        }) 
        const activeTabKey = computed(() => tabs.value[activeTab.value]?.key)

        // Нормализует id к числу, если это возможно
        const normalizeId = (id: any): any => {
            if (id === null || id === undefined) return id
            const numId = Number(id)
            return !isNaN(numId) && isFinite(numId) ? numId : id
        }

        const getStaffBanlist = () => {
            let banlist: any[] = []
            if (activeTabKey.value === 'app') {
                banlist = props.app.banOnStaff || []
            } else if (activeTabKey.value === 'trigger') {
                banlist = props.value?.banOnStaff || []
            }
            // Нормализуем все id к числу для корректного сравнения
            return banlist.map(id => normalizeId(id))
        }
        const updateStaffBanlist = (v: any[]) => {
            // Нормализуем все id к числу перед сохранением
            const normalized = v.map(id => normalizeId(id))
            if (activeTabKey.value === 'app') {
                emit('update-app', Object.assign({}, props.app, { banOnStaff: normalized }))
            }
            if (activeTabKey.value === 'trigger') {
                emit('input', Object.assign({}, props.value, { banOnStaff: normalized }))
            }
        }
        const getClientBanlist = () => {
            if (activeTabKey.value === 'app') {
                return props.app.banOnClient || []
            }
            if (activeTabKey.value === 'trigger') {
                return props.value?.banOnClient || []
            }
            return []
        }
        const updateClientBanlist = (v: any[]) => {
            if (activeTabKey.value === 'app') {
                emit('update-app', Object.assign({}, props.app, { banOnClient: v }))
            }
            if (activeTabKey.value === 'trigger') {
                emit('input', Object.assign({}, props.value, { banOnClient: v }))
            }
        }
        const onNumberInputChangeTransform = (v: string) => v.replace(/[^0-9+]/g, '')
        onMounted(async () => {
            if (hasYcConnector.value) {
                const staffData = await api.gcb2
                    .getRecodingStaffList({ projectId: project.value.id })
                    .then(res => res.data!) || []
                // Нормализуем id к числу для всех элементов staff
                staff.value = staffData.map((item: any) => ({
                    ...item,
                    id: normalizeId(item.id)
                }))
            }
        })
        return {
            trigger,
            getStaffBanlist,
            tabs,
            updateStaffBanlist,
            activeTab,
            staff,
            hasYcConnector,
            getClientBanlist,
            updateClientBanlist,
            onNumberInputChangeTransform,
            phoneValidator,
        }
    },
})
